//
// xRef Import/Column Mapping table.
// ---------------------------------------------------------------------------

'use strict';

const config = {
    formTarget: 'form[name=column_mappings]',
    headerTarget: 'input[name=header_row]',
    importTarget: 'button[type=submit]'
};

// Only attach event once we're sure we have the right DOM.
let form = $(config.formTarget);

if (form.length === 1) {
    form.find(config.headerTarget, form).on('change', () => {
        $(config.importTarget, form)
            .prop('disabled', true)
            .addClass('c-button--disabled');

        form.submit();
    });

    form.find(config.importTarget, form).on('click', () => {
        $(config.headerTarget, form)
            .prop('disabled', true);
    });
}




// WEBPACK FOOTER //
// ./src/js/components/xref-import-table.js